import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "../utils/ProtectedRoute";
import AppLayout from "../layouts/AppLayout";

import LoginPage from "../pages/LoginPage/LoginPage";
import BrokerSelectionPage from "../pages/BrokerSelectionPage/BrokerSelectionPage";
import UnAuthorizedPage from "../pages/UnAuthorizedPage";
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage";

import { getRoutableRoutes } from "./routesConfig";

function AppRoutes() {
  const routableRoutes = getRoutableRoutes();

  return (
    <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/select-broker" element={<BrokerSelectionPage />} />
        <Route element={<AppLayout />}>
          <Route
            path="/"
            element={
              <ProtectedRoute allowedRoles={["MASTER", "TRADER"]}>
                <Navigate to="/order-book" replace />
              </ProtectedRoute>
            }
          />
          {routableRoutes.map((route) => {
            const RouteComponent = route.component;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedRoute allowedRoles={route.roles}>
                    <RouteComponent />
                  </ProtectedRoute>
                }
              />
            );
          })}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <NotFoundPage />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="/un-authorized" element={<UnAuthorizedPage />} />
      </Routes>
  );
}

export default AppRoutes;
